/**
 * Which screen the CRF Builder's first load leads to.
 *
 * WHY THIS EXISTS. 2026-10-30, Clinical Dev, a study with 27 approved forms:
 * listCrfFormsV2 was cold (88.6 s), the browser gave up, and the page logged
 * "treating project as empty" and showed the Generate CRF List start screen,
 * from which Generate could replace approved forms. A failed load is not an
 * empty study. It is its own outcome, with its own screen.
 *
 * The packet marker only matters when there are no forms: with forms, the page
 * opens the workspace either way. So an unreadable marker is an error only
 * when the list is empty.
 */
export type FormListResult = { ok: true; forms: ReadonlyArray<{ status?: string }> } | { ok: false };
export type PacketMarkerResult = { ok: true; exists: boolean } | { ok: false };

export type CrfLanding = 'error' | 'resume-approved' | 'resume-draft' | 'no-forms';

export const CRF_LOAD_FAILED_MESSAGE =
  "This study's forms could not be loaded. This is usually a slow or unavailable server. Nothing has been changed. Select Retry, and if it keeps happening, contact support.";

export function decideCrfLanding(list: FormListResult, marker: PacketMarkerResult): CrfLanding {
  if (!list.ok) return 'error';
  if (list.forms.some((f) => f.status === 'approved' || f.status === 'final')) return 'resume-approved';
  if (list.forms.length > 0) return 'resume-draft';
  if (!marker.ok) return 'error';
  return marker.exists ? 'resume-draft' : 'no-forms';
}
